import { Module } from '@nestjs/common';
import { MonedasModule } from 'src/monedas/monedas.module';
import { winstonConfig } from '../common/logger/winston.config';
import { ListaPreciosModule } from '../lista-precios/lista-precios.module';
import { OfertasModule } from '../ofertas/ofertas.module';
import { PrismaModule } from '../prisma/prisma.module';
import { OrdenesVentaController } from './ordenes-venta.controller';
import { OrdenesVentaCron } from './ordenes-venta.cron';
import { PedidosController } from './pedidos.controller';
import { PedidosService } from './pedidos.service';

@Module({
  imports: [PrismaModule, ListaPreciosModule, MonedasModule, OfertasModule],
  controllers: [PedidosController, OrdenesVentaController],
  providers: [PedidosService, OrdenesVentaCron],
  exports: [PedidosService],
})
export class PedidosModule {}
